import _Object$keys from 'babel-runtime/core-js/object/keys';
import _mapValues from 'lodash/mapValues';

function convertTransformToAction(fn) {
  return function (state, props) {
    return fn(state)(props);
  };
}

function doDispatch(type) {
  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
    return x;
  };

  return function () {
    return { type: type, payload: fn.apply(undefined, arguments) };
  };
}

export default function builder(_ref) {
  var getInitialState = _ref.getInitialState,
      actionsRaw = _ref.actions;

  var actions = _mapValues(actionsRaw, convertTransformToAction);
  var module = function module(state, _ref2) {
    var type = _ref2.type,
        payload = _ref2.payload;

    if (typeof state === 'undefined') return getInitialState();
    if (!type || typeof actions[type] === 'undefined') return state;
    return actions[type](state, payload);
  };
  _Object$keys(actions).forEach(function (action) {
    module[action] = doDispatch(action);
  });
  return module;
}
//# sourceMappingURL=util.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/stores/util.js
// module id = 87
// module chunks = 0